import AutoCompleteField from '@Fields/AutoCompleteField';
import SelectField from '@Fields/SelectField';

class FitsToForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleFieldChanged = this.handleFieldChanged.bind(this);
        this.validatorFitsTo = this.validatorFitsTo.bind(this);

        this.state = FitsToForm.modelToState(props);

        //updates the parent's validator to use this method 
        var masterViewState = this.props.masterViewModel;
        masterViewState.validatorFitsTo = this.validatorFitsTo;
        this.state.IsInTranslationEditorMode = masterViewState.IsInTranslationEditorMode;
        this.props.handleFormUpdate(masterViewState);
    }

    static modelToState(props) {
        return {
            ManufacturerSelectedFitsTo: props.model.ManufacturerSelectedFitsTo,
            ManufacturersList: props.model.ManufacturersList,
            ModelSelectedFitsTo: props.model.ModelSelectedFitsTo,
            ModelList: props.model.ModelList,
            IndustrySelected: props.model.IndustrySelected,
            IndustryList: props.model.IndustryList,
            CategorySelected: props.model.CategorySelected,
            CategoriesList: props.model.CategoriesList,
            allCategoryOptions: props.model.CategoriesList,
            BaseCatID: props.model.BaseCatID,
            FitsToList: props.model.FitsToList,
            FitsToIndex: props.model.FitsToIndex,
            QueryString: props.model.QueryString,
            NextPageURL: props.model.NextPageURL,
            Translations: props.model.Translations,
            Progress: props.model.Progress,
            HighlightErrors: {},
            FormErrors: [],
            InputErrors: {},
            fitsToTable: null,
            ManufacturerDisabled: true,
            ModelDisabled: true
        };
    }

    //will execute this setState AFTER the state has receieved all the props. 
    componentDidMount() {
        this.buildFitsToTable(this.state);
    }

    rebuildFitsToTable(state) {
        this.setState({
            FitsToList: state.FitsToViewModel.FitsToList,
            CategoriesList: state.FitsToViewModel.CategoriesList,
            IndustryList: state.FitsToViewModel.IndustryList
        }, function () {
            this.buildFitsToTable(this.state);
        });
    }

    handleFieldChanged(field, value) {
        var state = this.state;
        state[field] = value;

        switch (field) {
            case "CategorySelected":
                // clear the manufacturer/model when category changes in case the manufacturer/model don't fit with the new category 
                this.state["ManufacturerSelectedFitsTo"] = "";
                this.state["ModelSelectedFitsTo"] = "";
                if (this.state.CategorySelected == 0) {
                    this.state["ManufacturerDisabled"] = true;
                    this.state["ModelDisabled"] = true;
                }
                else {
                    this.state["ManufacturerDisabled"] = false;
                    this.state["ModelDisabled"] = true;
                }
                // clear any errors for manufacturer and model
                this.state["HighlightErrors"].ManufacturerSelectedFitsTo = false;
                this.state["InputErrors"].ManufacturerSelectedFitsTo = "";
                this.state["HighlightErrors"].ModelSelectedFitsTo = false;
                this.state["InputErrors"].ModelSelectedFitsTo = "";
                break;
            case "ManufacturerSelectedFitsTo":
                if (state.ManufacturerSelectedFitsTo != null && state.ManufacturerSelectedFitsTo.length >= 2) {
                    var objectToSend = {
                        Manufacturer: state.ManufacturerSelectedFitsTo,
                        Category: state.CategorySelected,
                        BaseCategoryID: state.BaseCatID,
                        IsFitsTo: true,
                    }

                    var xhr1 = new XMLHttpRequest();
                    xhr1.onload = function () {
                        state = this.state;
                        if (xhr1.status == 200) {
                            var response = JSON.parse(xhr1.response);

                            state.ManufacturerSelectedFitsTo = this.state.ManufacturerSelectedFitsTo
                            if (response.TypedText == state.ManufacturerSelectedFitsTo) {
                                state.ManufacturersList = response.Manufacturers;
                            }
                            else {
                                state.ManufacturersList = this.state.ManufacturersList;
                            }
                            state["ModelDisabled"] = this.state["ModelDisabled"];
                            this.handleFormUpdate(state);
                        }
                    }.bind(this);

                    xhr1.open("POST", '/listinginput/ajax/UpdateManufacturerList', true);
                    xhr1.setRequestHeader("Content-type", "application/json");
                    xhr1.send(JSON.stringify(objectToSend));
                }
                else {
                    state.ManufacturersList = [];
                }
                break;
            case "ModelSelectedFitsTo":
                if (state.ManufacturerSelectedFitsTo != null && state.ManufacturerSelectedFitsTo.trim() != "" && state.ManufacturerSelectedFitsTo.length >= 2 &&
                    state.ModelSelectedFitsTo != null && state.ModelSelectedFitsTo.trim() != "" && state.ModelSelectedFitsTo.length >= 2) {
                    var objectToSend = {
                        Model: state.ModelSelectedFitsTo,
                        Manufacturer: state.ManufacturerSelectedFitsTo,
                        Category: state.CategorySelected,
                        BaseCategoryID: state.BaseCatID,
                        IsFitsTo: true,
                    }

                    var xhr2 = new XMLHttpRequest();
                    xhr2.onload = function () {
                        state = this.state;
                        if (xhr2.status == 200) {
                            var response = JSON.parse(xhr2.response);

                            state.ModelSelectedFitsTo = this.state.ModelSelectedFitsTo
                            if (response.TypedText == state.ModelSelectedFitsTo) {
                                state.ModelList = response.Models;
                            }
                            else {
                                state.ModelList = this.state.ModelList;
                            }

                            this.handleFormUpdate(state);
                        }
                    }.bind(this);

                    xhr2.open("POST", '/listinginput/ajax/UpdateModelList', true);
                    xhr2.setRequestHeader("Content-type", "application/json");
                    xhr2.send(JSON.stringify(objectToSend));
                }
                else {
                    state.ModelList = [];
                }
                break;
        }
        this.handleFormUpdate(state);
    }

    handleOnBlur(field, e) {
        switch (field) {
            case "ManufacturerSelectedFitsTo":
                // if there are no auto complete options or what is typed is not a match in the list then we have an invalid manufacturer
                if (this.state.ManufacturerSelectedFitsTo.length > 0 && (this.state.ManufacturersList.length == 0 || !this.state.ManufacturersList.includes(this.state.ManufacturerSelectedFitsTo.toUpperCase()))) {
                    // clear manufacturer field, disable model field and show invalid manufacturer error
                    this.state["ManufacturerSelectedFitsTo"] = "";
                    this.state["ModelDisabled"] = true;
                    this.state["HighlightErrors"].ManufacturerSelectedFitsTo = true;
                    this.state["InputErrors"].ManufacturerSelectedFitsTo = this.state.Translations["IsInvalid"].replace("{0}", this.state.Translations["Manufacturer"]);
                }
                else if (this.state.ManufacturerSelectedFitsTo.length == 0) {
                    // clear the error message and disable model if the user blurs an empty manufacturer field
                    this.state["HighlightErrors"].ManufacturerSelectedFitsTo = false;
                    this.state["InputErrors"].ManufacturerSelectedFitsTo = "";
                    this.state["ModelDisabled"] = true;
                }
                else {
                    // if valid manufacturer then enable the model field and clear any errors
                    this.state["ManufacturerSelectedFitsTo"] = this.state.ManufacturerSelectedFitsTo.toUpperCase();
                    this.state["ModelDisabled"] = false;
                    this.state["HighlightErrors"].ManufacturerSelectedFitsTo = false;
                    this.state["InputErrors"].ManufacturerSelectedFitsTo = "";
                    // to fix a bug where hitting tab with a valid manufacturer doesn't focus on the model field we have to manually disable and focus here
                    document.getElementById("ModelSelectedFitsTo").disabled = false;
                    document.getElementById("ModelSelectedFitsTo").focus();
                }
                // clear the model and any model errors in case the model is not valid for the new manufacturer
                this.state["ModelSelectedFitsTo"] = "";
                this.state["HighlightErrors"].ModelSelectedFitsTo = false;
                this.state["InputErrors"].ModelSelectedFitsTo = "";
                break;
            case "ModelSelectedFitsTo":
                // if there are no auto complete options or what is typed is not a match in the list then we have an invalid model
                if (this.state.ModelSelectedFitsTo.length > 0 && (this.state.ModelList.length == 0 || !this.state.ModelList.includes(this.state.ModelSelectedFitsTo.toUpperCase()))) {
                    this.state["ModelSelectedFitsTo"] = "";
                    this.state["HighlightErrors"].ModelSelectedFitsTo = true;
                    this.state["InputErrors"].ModelSelectedFitsTo = this.state.Translations["IsInvalid"].replace("{0}", this.state.Translations["Model"]);
                }
                else if (this.state.ModelSelectedFitsTo.length == 0) {
                    // clear the error message if the user blurs an empty field
                    this.state["HighlightErrors"].ModelSelectedFitsTo = false;
                    this.state["InputErrors"].ModelSelectedFitsTo = "";
                }
                else {
                    // valid model
                    this.state["ModelSelectedFitsTo"] = this.state.ModelSelectedFitsTo.toUpperCase();
                    this.state["HighlightErrors"].ModelSelectedFitsTo = false;
                    this.state["InputErrors"].ModelSelectedFitsTo = "";
                }
                break;
        }
        this.handleFormUpdate(this.state);
    }

    handleClickOnForm(e) {
        var state = this.state;
        //check if we received an fitsto index or a string
        var value = e;
        var type = typeof e;
        if (type != "string") {
            value = e.target.id;
        }

        switch (value) {
            case "addFitsTo":
                var highlighterrors = {};
                var inputerrors = {};

                //check required fields
                if (state.CategorySelected == "0" || state.CategorySelected == null || state.CategorySelected == "") {
                    highlighterrors.CategorySelected = true;
                    inputerrors.CategorySelected = this.state.Translations["ProvideOne"];
                }

                state.HighlightErrors = highlighterrors;
                state.InputErrors = inputerrors;
                state.FormErrors = state.FormErrors.filter(x => x !== state.Translations["MustProvide"]);

                //if we don't have any input errors
                if (Object.keys(inputerrors).length == 0) {

                    //create object to send, and make the ajax call
                    var objectToStringifyAdd = {};
                    objectToStringifyAdd.CategorySelected = state.CategorySelected;
                    objectToStringifyAdd.ManufacturerSelectedFitsTo = state.ManufacturerSelectedFitsTo;
                    objectToStringifyAdd.ModelSelectedFitsTo = state.ModelSelectedFitsTo;

                    var xhr = new XMLHttpRequest();
                    xhr.onload = function () {
                        var response = JSON.parse(xhr.response);

                        if (response.oFitsToViewModel.AddFitsTo) {
                            state.FitsToList = response.oFitsToViewModel.FitsToList;

                            this.buildFitsToTable(state);
                        }
                    }.bind(this);

                    xhr.open("POST", '/listinginput/fitsto/AddFitsTo' + state.QueryString, false);
                    xhr.setRequestHeader("Content-type", "application/json");
                    xhr.send(JSON.stringify(objectToStringifyAdd));
                }
                else {
                    this.handleFormUpdate(state);
                }
                break;
            case "deleteAll":

                //create object to send, and make the ajax call
                var objectToStringify = {
                    FitsToIndex: value
                };

                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    var response = JSON.parse(xhr.response);
                    state.FitsToList = response.oFitsToViewModel.FitsToList;
                    this.buildFitsToTable(state);
                }.bind(this);

                xhr.open("POST", '/listinginput/fitsto/DeleteFitsToAll' + state.QueryString, false);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToStringify));
                break;
            default: //"delete"

                //create object to send, and make the ajax call
                var index = Number(value);
                var objectToStringifyDelete = {
                    FitsToIndex: index
                };

                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    var response = JSON.parse(xhr.response);
                    state.FitsToList = response.oFitsToViewModel.FitsToList;
                    this.buildFitsToTable(state);
                }.bind(this);

                xhr.open("POST", '/listinginput/fitsto/DeleteFitsTo' + state.QueryString, false);
                xhr.setRequestHeader("Content-type", "application/json");
                xhr.send(JSON.stringify(objectToStringifyDelete));
                break;
        }
    }

    validatorFitsTo(button) {
        //return if the FitsTo has errors

        let highlightErrors = {};
        let formErrors = [];
        let inputErrors = {};

        if (this.state.FitsToList.length == 0) {
            formErrors.push(this.state.Translations["MustProvide"]);
            inputErrors.CategorySelected = "";

            setTimeout(function () {
                //open FitsTo if it's not open
                if ($('.fitsTo-options:visible').length != 0) {
                    FitsToOptionsToggle();
                }
                ScrollToElement($('.FitsToForm'));
            }, 400);
        }

        if (Object.keys(inputErrors).length == 0) {
            return false;
        }
        else {
            this.setState({
                HighlightErrors: highlightErrors,
                InputErrors: inputErrors,
                FormErrors: formErrors,
            });

            return true;
        }
    }

    handleFormUpdate(Model, callback) {
        this.setState({
            ManufacturerSelectedFitsTo: Model.ManufacturerSelectedFitsTo,
            ManufacturersList: Model.ManufacturersList,
            ModelSelectedFitsTo: Model.ModelSelectedFitsTo,
            ModelList: Model.ModelList,
            IndustrySelected: Model.IndustrySelected,
            IndustryList: Model.IndustryList,
            CategorySelected: Model.CategorySelected,
            CategoriesList: Model.CategoriesList,
            AllCategories: Model.AllCategories,
            allCategoryOptions: Model.allCategoryOptions,
            BaseCatID: Model.BaseCatID,
            FitsToList: Model.FitsToList,
            FitsToIndex: Model.FitsToIndex,
            QueryString: Model.QueryString,
            NextPageURL: Model.NextPageURL,
            Translations: Model.Translations,
            Progress: Model.Progress,
            HighlightErrors: Model.HighlightErrors,
            FormErrors: Model.FormErrors,
            InputErrors: Model.InputErrors,
            fitsToTable: Model.fitsToTable,
            ManufacturerDisabled: Model.ManufacturerDisabled,
            ModelDisabled: Model.ModelDisabled
        }, callback);
    }

    buildFitsToTable(state, callback) {

        var _fitsToTable = [];
        var _fitsToElements = [];

        //if there is no fitsTos, do not build the table
        if (state.FitsToList != null && state.FitsToList.length !== 0) {
            //For each FitsTo item we have, create a table row. using a for loop instead of for each because we need index i for the onclick methods.
            for (var i = 0; i < state.FitsToList.length; i++) {
                var _fitsToElement = state.FitsToList[i];
                _fitsToElements.push(
                    <tr key={i}>
                        <td className="FitsToElement">{_fitsToElement.FullCategory}</td>
                        <td className="FitsToElement">{_fitsToElement.Manufacturer}</td>
                        <td className="FitsToElement">{_fitsToElement.Model}</td>
                        <td className="FitsToElement">
                            <button role="link" id={i} className="deleteFitsTo" onClick={(e) => { this.handleClickOnForm(e); }}>{this.getTranslation("Delete")}</button>
                        </td>
                    </tr>
                );
            }

            //create table
            _fitsToTable.push(
                <div key={0} className="divFitsToHolder">
                    <table key={1} className="FitsToTable">
                        <tbody key={2}>
                            <tr key={3} className="FitsToHeader">
                                <th style={{ width: "150px" }} className="siteFontColor PrimaryBGC">{this.getTranslation("Category")}</th>
                                <th style={{ width: "150px" }} className="siteFontColor PrimaryBGC">{this.getTranslation("Manufacturer")}</th>
                                <th style={{ width: "150px" }} className="siteFontColor PrimaryBGC">{this.getTranslation("Model")}</th>
                                <th style={{ width: "150px" }} className="siteFontColor PrimaryBGC">
                                    <button role="link" className="deleteFitsToHeader siteFontColor" onClick={(e) => { this.handleClickOnForm("deleteAll"); }}>{this.getTranslation("DeleteAll")}</button>
                                </th>
                            </tr>
                            {_fitsToElements}
                        </tbody>
                    </table>
                </div>
            );
        }

        //send table to the state
        state.fitsToTable = _fitsToTable;
        this.handleFormUpdate(state, callback);
    }

    getTranslation(key) {
        return this.state.IsInTranslationEditorMode ?
            <span dangerouslySetInnerHTML={{ __html: this.state.Translations[key] }}></span> :
            this.state.Translations[key];
    }

    render() {
        return (
            <div className="FitsToForm" style={{ paddingBottom: '20px' }}>
                <div className="additional-prices" onClick={(e) => { FitsToOptionsToggle() }} style={{ marginTop: '5px' }}>
                    <div className="fitsTo-options" style={{ display: 'none' }}>
                        <strong style={{ display: 'block' }}>{this.getTranslation("FitsTo")} <i className="fa fa-plus" aria-hidden="true"></i></strong>
                        {this.getTranslation("EquipmentThisAttachmentWillFit")}...
                    </div>
                    <div className="fitsTo-options-2">
                        <strong>{this.getTranslation("CloseFitsTo")} <i className="fa fa-minus" aria-hidden="true"></i></strong>
                    </div>
                </div>
                <div className="fitsTo-content" style={{ padding: '20px 25px' }}>
                    <div className="validationError" style={{ textAlign: 'center' }}>
                        <span>{this.state.FormErrors}</span>
                    </div>
                    <p>
                        {this.getTranslation("EquipmentThisAttachmentWillFit")} <span style={{ color: '#CC0000', fontWeight: 'bold' }}>{this.getTranslation("ClickToAddFitsTo")}</span>{this.getTranslation("AfterYoureFinishedSelecting")}
                    </p>

                    {/*Category*/}
                    <div className="fe-section cf">
                        <div className="form-row cf">
                            <label className="label-left" htmlFor="CategorySelectedFitsTo">{this.getTranslation("Category")} <span>*</span></label>
                            <div className="input-right">
                                <SelectField
                                    id="CategorySelectedFitsTo"
                                    value={this.state.CategorySelected}
                                    values={this.state.CategoriesList}
                                    onFieldChanged={(e) => { this.handleFieldChanged("CategorySelected", e); }}
                                    bShowFullName={true}
                                    error={this.state.HighlightErrors.CategorySelected}
                                    errorText={this.state.InputErrors.CategorySelected}
                                    hasLabel={true}
                                />
                            </div>
                        </div>
                    </div>

                    {/*Manufacturer*/}
                    <div className="form-row cf">
                        <label className="label-left" htmlFor="ManufacturerSelectedFitsTo">{this.getTranslation("Manufacturer")}</label>
                        <div className="input-right">
                            <AutoCompleteField
                                id="ManufacturerSelectedFitsTo"
                                FromList={true}
                                disabled={this.state.ManufacturerDisabled}
                                value={this.state.ManufacturerSelectedFitsTo}
                                values={this.state.ManufacturersList}
                                onFieldChanged={(e) => { this.handleFieldChanged("ManufacturerSelectedFitsTo", e); }}
                                onBlur={(e) => { this.handleOnBlur("ManufacturerSelectedFitsTo", e); }}
                                error={this.state.HighlightErrors.ManufacturerSelectedFitsTo}
                                errorText={this.state.InputErrors.ManufacturerSelectedFitsTo}
                                hasLabel={true}
                            />
                        </div>
                    </div>

                    {/*Model*/}
                    <div className="form-row cf">
                        <label className="label-left" htmlFor="ModelSelectedFitsTo">{this.getTranslation("Model")}</label>
                        <div className="input-right">
                            <AutoCompleteField
                                id="ModelSelectedFitsTo"
                                FromList={true}
                                disabled={this.state.ModelDisabled}
                                value={this.state.ModelSelectedFitsTo}
                                values={this.state.ModelList}
                                onFieldChanged={(e) => { this.handleFieldChanged("ModelSelectedFitsTo", e); }}
                                onBlur={(e) => { this.handleOnBlur("ModelSelectedFitsTo", e); }}
                                error={this.state.HighlightErrors.ModelSelectedFitsTo}
                                errorText={this.state.InputErrors.ModelSelectedFitsTo}
                                hasLabel={true}
                            />
                        </div>
                    </div>

                    {/*Button to add a new FT record*/}
                    <div className="half" style={{ textAlign: 'right' }}>
                        <button role="link" tabIndex="0" className="btn fitsto-btn PrimaryBGC preserveDefaultBehaviorWithTranslationEditor siteFontColor" style={{ marginTop: '0px !important' }} onClick={(e) => { this.handleClickOnForm("addFitsTo"); }}> <strong> {this.getTranslation("AddFitsTo")}</strong></button>
                    </div>
                    <div>
                        {this.state.fitsToTable}
                    </div>
                </div>
            </div>
        );
    }
}

export default FitsToForm;
global.FitsToForm = FitsToForm;
